/**
 * International Shipping Quote — Country Detection
 *
 * Uses only the Liquid market country (window.__kwcLiquidCountry) to determine
 * whether a visitor is in a non-rated (international) shipping zone. This keeps
 * PDP server-side gating (localization.country.iso_code) and client-side class
 * toggling in sync, eliminating split-brain state.
 *
 * This store is single-domain with a country/currency dropdown. Shopify Markets
 * auto-redirect is NOT available on this architecture (it requires domain- or
 * subdomain-separated markets), so the dropdown is the sole way a visitor
 * switches markets. IP-based auto-switching is deliberately not used because it
 * caused the original Issue 3 PDP/cart split-brain.
 */
(function () {
  'use strict';

  var INTL_CLASS = 'is-international';
  var RATED = window.__kwcRatedCountries || ['GB'];

  function applyClass(country) {
    if (country && RATED.indexOf(country) === -1) {
      document.body.classList.add(INTL_CLASS);
    } else {
      document.body.classList.remove(INTL_CLASS);
    }
  }

  // Use the Liquid market country as the sole signal — matches PDP server-side gating.
  applyClass(window.__kwcLiquidCountry || 'GB');
})();
